import { configureStore } from "@reduxjs/toolkit";
import userModeReducer from "./slices/userModeSlice";
import gameSettingsReducer from "./slices/gameSettingsSlice";
import gameDataReducer from "./slices/gameDataSlice";
import finishedTilesArrayReducer from "./slices/finishedTilesArraySlice";
import userReducer from "./slices/userSlice";
import soundsReducer from "./slices/soundsSlice";
// import logger from "redux-logger";

export default configureStore({
  reducer: {
    user: userReducer,
    userMode: userModeReducer,
    gameSettings: gameSettingsReducer,
    finishedTilesArray: finishedTilesArrayReducer,
    gameData: gameDataReducer,
    sounds: soundsReducer,
  },
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
});
